export enum UtilityScanModal {
  CUSTOMS_ON_HOLD = "CUSTOMS_ON_HOLD",
  CUSTOMS_UNKNOWN_ERROR = "CUSTOMS_UNKNOWN_ERROR",
  TRACKING_CODE_NOT_FOUND = "TRACKING_CODE_NOT_FOUND",
  UNKNOWN_CUSTOMS_STATUS = "UNKNOWN_CUSTOMS_STATUS",
}
